export default {
  variants: {
    simple: {
      thead: {
        background: 'gray.100',
        border: '1px solid',
        borderColor: 'gray.500',
      },
      th: {
        borderRight: '1px solid',
        borderBottom: 'none',
        borderRightColor: 'gray.500',
        textTransform: 'none',
        color: 'black',
        fontFamily: 'inherit',
        fontWeight: 500,
        verticalAlign: 'top',
        letterSpacing: 'normal',
      },
      td: {
        borderColor: 'gray.500',
        fontFamily: 'inherit',
        color: 'black',
        fontWeight: 400,
        verticalAlign: 'top',
      },
    },
    striped: {
      thead: {
        background: 'gray.100',
        border: '1px solid',
        borderColor: 'gray.500',
      },
      th: {
        borderRight: '1px solid',
        borderBottom: 'none',
        borderRightColor: 'gray.500',
        textTransform: 'none',
        color: 'black',
        fontFamily: 'inherit',
        fontWeight: 500,
        verticalAlign: 'top',
        letterSpacing: 'normal',
      },
      td: {
        fontFamily: 'inherit',
        color: 'black',
        fontWeight: 400,
        verticalAlign: 'top',
      },
      tbody: {
        tr: {
          '&:nth-of-type(odd)': {
            td: {
              background: 'gray.100',
            },
          },
        },
      },
    },
    unstyled: {
      thead: {
        border: '1px solid',
        borderColor: 'transparent',
      },
      th: {
        borderRight: '1px solid',
        borderBottom: 'none',
        borderRightColor: 'transparent',
        textTransform: 'none',
        color: 'black',
        fontFamily: 'inherit',
        fontWeight: 500,
        verticalAlign: 'top',
        letterSpacing: 'normal',
      },
      td: {
        borderColor: 'transparent',
        fontFamily: 'inherit',
        color: 'black',
        fontWeight: 400,
        verticalAlign: 'top',
      },
    },
  },
  sizes: {
    sm: {
      th: {
        px: '0.5rem',
        py: '0.5rem',
        lineHeight: '1rem',
        fontSize: '0.925rem',
      },
      td: {
        px: '0.5rem',
        py: '0.5rem',
        lineHeight: '1rem',
        fontSize: '0.925rem',
      },
    },
    md: {
      th: {
        px: '0.75rem',
        py: '0.75rem',
        lineHeight: '1rem',
        fontSize: '0.925rem',
      },
      td: {
        px: '0.75rem',
        py: '0.75rem',
        lineHeight: '1rem',
        fontSize: '0.925rem',
      },
    },
    lg: {
      th: {
        px: '1rem',
        py: '1rem',
        lineHeight: '1rem',
        fontSize: '0.925rem',
      },
      td: {
        px: '1rem',
        py: '1rem',
        lineHeight: '1rem',
        fontSize: '0.925rem',
      },
    },
  },
  defaultProps: {
    variant: 'simple',
    size: 'sm',
  },
}
